module.exports = __webpack_public_path__ + "static/media/account_details.b755d2fd.png";